import DataController from 'components/DataController/DataController';
import Text from 'components/Text/Text';
import {
	IScheduleViewContext,
	ScheduleViewContext,
} from '../../../scheduleViewContext/scheduleViewState/scheduleViewContext';
import moment from 'moment';
import React, { useContext, useMemo } from 'react';
import { IItemScheduledPush } from 'types';
import RestaurantsList from 'components/Lists/CardView/RestaurantsList';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemScheduledPush;
	index: number;
}

const Item: React.FC<IItem> = ({ data, index }) => {
	const { setIDForDeletion, setIDForEdit } = useContext<IScheduleViewContext>(ScheduleViewContext);

	const pushesRowClasses = classNames(style.pushes, style.row);
	const statusRowClasses = classNames(style.status, style.row);
	const restaurantRowClasses = classNames(style.restaurant, style.row);
	const dateTimeRowClasses = classNames(style.dateTime, style.row);
	const actionRowClasses = classNames(style.action, style.row);

	const formattedDate = moment(data.scheduledDateTime).format('DD.MM.YYYY / HH:mm');

	const hideActions = data.status === 'Failed' || data.status === 'Sent';

	const restaurantList = useMemo(() => {
		return data.restaurants.map((el) => ({ id: el.id, restaurantName: el.name }));
	}, [data]);

	const handleSetIdForDeletion = () => {
		setIDForDeletion(data.id);
	};

	const handleEdit = () => {
		setIDForEdit(data.id);
	};

	return (
		<div data-test={`Item-${index}`}>
			<div className={style.container}>
				<Text
					className={pushesRowClasses}
					translationNameSpace="form"
					translationKey={data.type}
					withTooltip={true}
				/>
				<Text
					className={statusRowClasses}
					translationNameSpace="form"
					translationKey={data.status}
					withTooltip={true}
				/>
				<div className={restaurantRowClasses}>
					<RestaurantsList restaurants={restaurantList} />
				</div>
				<Text className={dateTimeRowClasses} translationKey={formattedDate} withTooltip={true} />
				<div className={actionRowClasses}>
					{!hideActions && (
						<DataController
							onClickDelete={handleSetIdForDeletion}
							onClickEdit={handleEdit}
							size="smallBtn"
						/>
					)}
				</div>
			</div>
		</div>
	);
};

export default React.memo(Item);
